export const es = {
  menu: {
    root: 'Inventario',
    levels: 'Niveles de Inventario',
    lots: 'Lotes de Inventario',
    tags: 'Etiquetas de Inventario',
    periods: 'Periodos de Inventario',
    locations: 'Ubicaciones',
    zones: 'Zonas',
    cycleCountSchedules: 'Programas de Conteo',
    counts: 'Conteos Cíclicos',
  },
  inventoryLevelsView: {
    title: 'Niveles de Inventario',
    subtitle:
      'Seguimiento de cantidades actuales de inventario por artículo e instalación',
    viewModes: {
      ourMaterial: 'Nuestro Material',
      tollingMaterial: 'Material de Maquila',
    },
    filters: {
      search: 'Buscar artículos...',
      allFacilities: 'Todas las Instalaciones',
      allLocations: 'Todas las Ubicaciones',
      ourFacilities: 'Nuestras Instalaciones',
      externalProcessors: 'Procesadores Externos',
      allZones: 'Todas las Zonas',
      allQuantities: 'Todas las cantidades',
      hideZeroQuantity: 'Ocultar cantidad cero',
      negativeOnly: 'Solo negativos',
    },
    summary: {
      totalItems: 'Total de Artículos',
      itemsWithStock: 'Artículos con Stock',
      totalQuantity: 'Cantidad Total',
    },
    table: {
      aria: 'Lista de Niveles de Inventario',
      noFacility: 'Sin Instalación',
      columns: {
        item: 'Artículo',
        facility: 'Instalación',
        location: 'Ubicación',
        owner: 'Propietario',
        quantity: 'Cantidad',
        totalValue: 'Valor Total',
        wac: 'WAC',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar niveles de inventario: ${message}`,
    },
    groups: {
      ungrouped: 'Sin agrupar',
      items: (count: number) => `${count} artículo${count !== 1 ? 's' : ''}`,
    },
    emptyState: {
      title: 'No se encontró inventario',
      subtitle:
        'Ningún nivel de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda.',
    },
  },
  movementHistoryView: {
    title: 'Historial de Movimientos',
    subtitle: (itemName: string) =>
      `Movimientos de inventario para ${itemName}`,
    inventoryDetails: 'Detalles de inventario',
    backToLevels: 'Volver a Niveles de Inventario',
    tabs: {
      facilities: 'Instalaciones',
      history: 'Historial',
    },
    facilityBreakdown: {
      facility: 'Instalación',
      quantity: 'Cantidad',
      totalValue: 'Valor Total',
      wac: 'CPC',
    },
    facilitySelector: 'Instalación',
    filters: {
      allFacilities: 'Todas las Instalaciones',
    },
    table: {
      aria: 'Historial de Movimientos de Inventario',
      columns: {
        date: 'Fecha',
        type: 'Tipo',
        transaction: 'Transacción',
        quantity: 'Cantidad',
        cost: 'Costo',
        status: 'Estado',
        originator: 'Origen',
        runningQuantity: 'Cant. Acumulada',
        runningValue: 'Valor Acumulado',
        runningWac: 'CPC Acumulado',
      },
    },
    movementTypes: {
      In: 'Entrada',
      Out: 'Salida',
      Internal: 'Interno',
      Reset: 'Reinicio',
    },
    transactionTypes: {
      Purchase: 'Compra',
      Sale: 'Venta',
      Transfer: 'Transferencia',
      Tagging: 'Etiquetado',
      Untagging: 'Desetiquetado',
      Processing: 'Procesamiento',
      Upgrade: 'Mejora',
      Downgrade: 'Degradación',
      Accounting: 'Contabilidad',
      BalanceAdjustment: 'Ajuste de Saldo',
      PhysicalInventory: 'Inventario Físico',
      PurchaseReversion: 'Reversión de Compra',
      SaleReversion: 'Reversión de Venta',
      TransferReversion: 'Reversión de Transferencia',
    },
    statusTypes: {
      Pending: 'Pendiente',
      InTransit: 'En Tránsito',
      Completed: 'Completado',
      Canceled: 'Cancelado',
    },
    content: {
      error: (message: string) =>
        `Error al cargar historial de movimientos: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron movimientos',
      subtitle: 'Este artículo no tiene movimientos de inventario registrados.',
    },
    actions: {
      allocateToLot: 'Asignar a Lote',
    },
  },
  lotsListView: {
    title: 'Lotes de Inventario',
    subtitle: 'Administrar lotes de inventario discretos por instalación',
    createLot: 'Crear Lote',
    filters: {
      search: 'Buscar lotes...',
      allFacilities: 'Todas las Instalaciones',
      allStatuses: 'Todos los Estados',
    },
    summary: {
      totalLots: 'Total de Lotes',
      activeLots: 'Lotes Activos',
      closedLots: 'Lotes Cerrados',
    },
    table: {
      aria: 'Lista de Lotes de Inventario',
      columns: {
        lotNumber: 'Número de Lote',
        facility: 'Instalación',
        status: 'Estado',
        quantity: 'Cantidad',
        items: 'Artículos',
        createdAt: 'Creado',
      },
      moreItems: (count: number) => `+${count} más`,
      emptyLot: '—',
    },
    statusTypes: {
      Active: 'Activo',
      Closed: 'Cerrado',
      Merged: 'Fusionado',
    },
    content: {
      error: (message: string) =>
        `Error al cargar lotes de inventario: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron lotes',
      subtitle:
        'Ningún lote de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo lote.',
    },
    dialog: {
      createTitle: 'Crear Lote de Inventario',
      editTitle: 'Editar Lote de Inventario',
      lotNumberLabel: 'Número de Lote',
      lotNumberPlaceholder: 'Ingrese número de lote...',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione una instalación...',
      locationLabel: 'Ubicación',
      locationPlaceholder: 'Seleccione una ubicación...',
      noLocation: 'Sin Ubicación',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Descripción opcional...',
      statusLabel: 'Estado',
      cancel: 'Cancelar',
      create: 'Crear Lote',
      creating: 'Creando...',
      update: 'Actualizar Lote',
      updating: 'Actualizando...',
      createSuccess: 'Lote creado exitosamente',
      updateSuccess: 'Lote actualizado exitosamente',
      createError: (message: string) => `Error al crear lote: ${message}`,
      updateError: (message: string) => `Error al actualizar lote: ${message}`,
      unknownError: 'Error desconocido',
      validation: {
        lotNumberRequired: 'El número de lote es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
    allocation: {
      allocateToLot: 'Asignar a Lote',
      addMovements: 'Agregar Movimientos',
      selectLot: 'Seleccione un lote',
      quantity: 'Cantidad',
      maxAvailable: (max: number, unit: string) => `Máx: ${max} ${unit}`,
      success: 'Asignado al lote exitosamente',
      error: 'Error al asignar al lote',
      noEligibleMovements: 'No se encontraron movimientos elegibles',
      noMovementsSelected: 'No se seleccionaron movimientos',
      movementsToAllocate: 'Movimientos a Asignar',
      allocate: 'Asignar',
      searchMovements: 'Buscar Movimientos',
      searchPlaceholder:
        'Buscar por nombre de artículo o número de movimiento...',
      loadingMovements: 'Cargando movimientos...',
      errorLoadingMovements:
        'Error al cargar los movimientos. Por favor intente nuevamente.',
      selectedMovements: (count: number) =>
        `Movimientos Seleccionados (${count})`,
      addToLot: 'Agregar al Lote',
    },
    detail: {
      title: (lotNumber: string) => `Lote ${lotNumber}`,
      backToLots: 'Volver a Lotes',
      allocations: 'Asignaciones',
      noAllocations: 'No hay movimientos asignados a este lote',
      addMovements: 'Agregar Movimientos',
      edit: 'Editar',
      closeLot: 'Cerrar Lote',
      deallocate: 'Desasignar',
      deallocateSuccess: 'Movimientos desasignados exitosamente',
      deallocateError: 'Error al desasignar movimientos',
      deallocateConfirm: (count: number) =>
        `¿Desasignar ${count} asignación${count > 1 ? 'es' : ''}?`,
      deallocateConfirmDescription:
        'Esto eliminará las asignaciones seleccionadas de este lote. Los movimientos quedarán sin asignar.',
      toolbar: {
        selected: 'seleccionados',
        deallocate: 'Desasignar',
      },
      table: {
        aria: 'Asignaciones del Lote',
        columns: {
          source: 'Origen',
          type: 'Tipo',
          item: 'Artículo',
          quantity: 'Cantidad',
          date: 'Asignado',
        },
        tagged: 'Etiquetado',
        loose: 'Suelto',
      },
      summary: {
        title: 'Resumen',
        totalItems: 'Artículos',
        totalQuantity: 'Cantidad Total',
      },
    },
  },
  locationsListView: {
    title: 'Ubicaciones de Inventario',
    subtitle:
      'Administrar ubicaciones de almacenamiento dentro de instalaciones',
    createLocation: 'Crear Ubicación',
    filters: {
      search: 'Buscar ubicaciones...',
      allFacilities: 'Todas las Instalaciones',
      allTypes: 'Todos los Tipos',
      allStatuses: 'Todos los Estados',
    },
    summary: {
      totalLocations: 'Total de Ubicaciones',
      activeLocations: 'Activas',
      closedLocations: 'Cerradas',
      archivedLocations: 'Archivadas',
    },
    table: {
      aria: 'Lista de Ubicaciones de Inventario',
      columns: {
        locationCode: 'Código de Ubicación',
        facility: 'Instalación',
        parentLocation: 'Padre',
        locationType: 'Tipo',
        status: 'Estado',
        capacity: 'Capacidad',
        createdAt: 'Creado',
      },
    },
    locationTypes: {
      Zone: 'Zona',
      Aisle: 'Pasillo',
      Shelf: 'Estante',
      Bin: 'Contenedor',
      Other: 'Otro',
    },
    statusTypes: {
      Active: 'Activo',
      Closed: 'Cerrado',
      Archived: 'Archivado',
    },
    content: {
      error: (message: string) =>
        `Error al cargar ubicaciones de inventario: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron ubicaciones',
      subtitle:
        'Ninguna ubicación de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree una nueva ubicación.',
    },
    actions: {
      edit: 'Editar',
      close: 'Cerrar Ubicación',
      archive: 'Archivar Ubicación',
      closeSuccess: 'Ubicación cerrada exitosamente',
      closeError: (message: string) => `Error al cerrar ubicación: ${message}`,
      archiveSuccess: 'Ubicación archivada exitosamente',
      archiveError: (message: string) =>
        `Error al archivar ubicación: ${message}`,
    },
    confirmClose: {
      title: 'Cerrar Ubicación',
      description: (code: string) =>
        `¿Está seguro de que desea cerrar la ubicación "${code}"? Las ubicaciones cerradas no pueden recibir nuevo inventario.`,
      confirm: 'Cerrar Ubicación',
      cancel: 'Cancelar',
    },
    confirmArchive: {
      title: 'Archivar Ubicación',
      description: (code: string) =>
        `¿Está seguro de que desea archivar la ubicación "${code}"? Las ubicaciones archivadas se ocultarán de la lista principal.`,
      confirm: 'Archivar Ubicación',
      cancel: 'Cancelar',
    },
    dialog: {
      createTitle: 'Crear Ubicación de Inventario',
      editTitle: 'Editar Ubicación de Inventario',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione una instalación...',
      parentLocationLabel: 'Ubicación Padre',
      parentLocationPlaceholder: 'Seleccione ubicación padre...',
      noParent: 'Sin padre (nivel superior)',
      locationCodeLabel: 'Código de Ubicación',
      locationCodePlaceholder: 'Ingrese código de ubicación...',
      nameLabel: 'Nombre',
      namePlaceholder: 'Ingrese nombre de ubicación...',
      locationTypeLabel: 'Tipo de Ubicación',
      capacityValueLabel: 'Capacidad',
      capacityValuePlaceholder: 'Ingrese capacidad...',
      capacityUnitLabel: 'Unidad',
      capacityUnitPlaceholder: 'ej., pallets',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Descripción opcional...',
      cancel: 'Cancelar',
      create: 'Crear Ubicación',
      creating: 'Creando...',
      update: 'Actualizar Ubicación',
      updating: 'Actualizando...',
      createSuccess: 'Ubicación creada exitosamente',
      updateSuccess: 'Ubicación actualizada exitosamente',
      createError: (message: string) => `Error al crear ubicación: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar ubicación: ${message}`,
      unknownError: 'Error desconocido',
      validation: {
        locationCodeRequired: 'El código de ubicación es obligatorio',
        nameRequired: 'El nombre es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
  },
  zonesListView: {
    title: 'Zonas de Inventario',
    subtitle: 'Administrar zonas de almacenamiento dentro de instalaciones',
    createZone: 'Crear Zona',
    filters: {
      search: 'Buscar zonas...',
      allFacilities: 'Todas las Instalaciones',
      allTypes: 'Todos los Tipos',
      allStatuses: 'Todos los Estados',
    },
    summary: {
      totalZones: 'Total de Zonas',
      activeZones: 'Activas',
      closedZones: 'Cerradas',
      archivedZones: 'Archivadas',
    },
    table: {
      aria: 'Lista de Zonas de Inventario',
      columns: {
        zoneCode: 'Código de Zona',
        facility: 'Instalación',
        parentZone: 'Padre',
        zoneType: 'Tipo',
        status: 'Estado',
        capacity: 'Capacidad',
        createdAt: 'Creado',
      },
    },
    zoneTypes: {
      Zone: 'Zona',
      Aisle: 'Pasillo',
      Shelf: 'Estante',
      Bin: 'Contenedor',
      Other: 'Otro',
    },
    statusTypes: {
      Active: 'Activo',
      Closed: 'Cerrado',
      Archived: 'Archivado',
    },
    content: {
      error: (message: string) =>
        `Error al cargar zonas de inventario: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron zonas',
      subtitle:
        'Ninguna zona de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree una nueva zona.',
    },
    actions: {
      edit: 'Editar',
      close: 'Cerrar Zona',
      archive: 'Archivar Zona',
      closeSuccess: 'Zona cerrada exitosamente',
      closeError: (message: string) => `Error al cerrar zona: ${message}`,
      archiveSuccess: 'Zona archivada exitosamente',
      archiveError: (message: string) => `Error al archivar zona: ${message}`,
    },
    confirmClose: {
      title: 'Cerrar Zona',
      description: (code: string) =>
        `¿Está seguro de que desea cerrar la zona "${code}"? Las zonas cerradas no pueden recibir nuevo inventario.`,
      confirm: 'Cerrar Zona',
      cancel: 'Cancelar',
    },
    confirmArchive: {
      title: 'Archivar Zona',
      description: (code: string) =>
        `¿Está seguro de que desea archivar la zona "${code}"? Las zonas archivadas se ocultarán de la lista principal.`,
      confirm: 'Archivar Zona',
      cancel: 'Cancelar',
    },
    dialog: {
      createTitle: 'Crear Zona de Inventario',
      editTitle: 'Editar Zona de Inventario',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione una instalación...',
      parentZoneLabel: 'Zona Padre',
      parentZonePlaceholder: 'Seleccione zona padre...',
      noParent: 'Sin padre (nivel superior)',
      zoneCodeLabel: 'Código de Zona',
      zoneCodePlaceholder: 'Ingrese código de zona...',
      nameLabel: 'Nombre',
      namePlaceholder: 'Ingrese nombre de zona...',
      zoneTypeLabel: 'Tipo de Zona',
      capacityValueLabel: 'Capacidad',
      capacityValuePlaceholder: 'Ingrese capacidad...',
      capacityUnitLabel: 'Unidad',
      capacityUnitPlaceholder: 'ej., pallets',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Descripción opcional...',
      cancel: 'Cancelar',
      create: 'Crear Zona',
      creating: 'Creando...',
      update: 'Actualizar Zona',
      updating: 'Actualizando...',
      createSuccess: 'Zona creada exitosamente',
      updateSuccess: 'Zona actualizada exitosamente',
      createError: (message: string) => `Error al crear zona: ${message}`,
      updateError: (message: string) => `Error al actualizar zona: ${message}`,
      unknownError: 'Error desconocido',
      validation: {
        zoneCodeRequired: 'El código de zona es obligatorio',
        nameRequired: 'El nombre es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
  },
  periodsListView: {
    title: 'Periodos de Inventario',
    subtitle:
      'Administrar periodos de contabilidad de inventario por instalación',
    filters: {
      allFacilities: 'Todas las Instalaciones',
      allStatuses: 'Todos los Estados',
    },
    table: {
      aria: 'Lista de Periodos de Inventario',
      columns: {
        name: 'Nombre',
        facility: 'Instalación',
        status: 'Estado',
        startDate: 'Fecha de Inicio',
        endDate: 'Fecha de Fin',
        lockedAt: 'Bloqueado En',
      },
    },
    statusTypes: {
      Open: 'Abierto',
      Closed: 'Cerrado',
      Locked: 'Bloqueado',
      Archived: 'Archivado',
    } as Record<string, string>,
    content: {
      error: (message: string) =>
        `Error al cargar periodos de inventario: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron periodos',
      subtitle:
        'Ningún periodo de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda.',
    },
    actions: {
      lock: 'Bloquear Periodo',
      unlock: 'Desbloquear Periodo',
      archive: 'Archivar Periodo',
      lockSuccess: 'Periodo bloqueado exitosamente',
      lockError: (message: string) => `Error al bloquear periodo: ${message}`,
      unlockSuccess: 'Periodo desbloqueado exitosamente',
      unlockError: (message: string) =>
        `Error al desbloquear periodo: ${message}`,
      archiveSuccess: 'Periodo archivado exitosamente',
      archiveError: (message: string) =>
        `Error al archivar periodo: ${message}`,
      unknownError: 'Error desconocido',
    },
    lockDialog: {
      title: 'Bloquear Periodo',
      description: (name: string) =>
        `Revise la lista de verificación antes de bloquear el periodo "${name}".`,
      checklistTitle: 'Lista de Verificación Pre-Bloqueo',
      blockingWarning:
        'Los elementos bloqueantes deben resolverse antes de bloquear este periodo.',
      confirm: 'Bloquear Periodo',
      cancel: 'Cancelar',
    },
    unlockDialog: {
      title: 'Desbloquear Periodo',
      description: (name: string) =>
        `Desbloquear temporalmente el periodo "${name}" para correcciones.`,
      reasonLabel: 'Razón',
      reasonPlaceholder: 'Ingrese la razón para desbloquear este periodo...',
      durationLabel: 'Duración de Auto-Bloqueo',
      confirm: 'Desbloquear Periodo',
      cancel: 'Cancelar',
      validation: {
        reasonRequired: 'Se requiere una razón para desbloquear el periodo',
      },
    },
    detail: {
      title: (name: string) => `Periodo: ${name}`,
      backToPeriods: 'Volver a Periodos',
      overview: 'Resumen',
      periodInfo: 'Información del Periodo',
      autoCloseInfo: (endDate: string) =>
        `Este periodo se cerrará automáticamente el ${endDate}.`,
      autoRelockInfo: (expiresAt: string) =>
        `Este periodo se volverá a bloquear automáticamente el ${expiresAt}.`,
      fields: {
        name: 'Nombre',
        facility: 'Instalación',
        periodType: 'Tipo de Periodo',
        startDate: 'Fecha de Inicio',
        endDate: 'Fecha de Fin',
        status: 'Estado',
        closedAt: 'Cerrado En',
        lockedAt: 'Bloqueado En',
        unlockReason: 'Razón de Desbloqueo',
        notes: 'Notas',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
      },
      balanceSnapshot: 'Instantánea de Saldo',
      balanceTable: {
        aria: 'Instantánea de Saldo del Periodo',
        empty: 'No hay datos de saldo disponibles',
        columns: {
          item: 'Artículo',
          account: 'Cuenta',
          quantity: 'Cantidad',
          wacPerUnit: 'WAC/Unidad',
          totalValue: 'Valor Total',
        },
      },
    },
    periodConfig: {
      configureButton: 'Configurar',
      createTitle: 'Configurar Periodos de Inventario',
      editTitle: 'Editar Configuración de Periodos',
      sections: {
        periodSettings: 'Configuración de Periodos',
        straddleSettings: 'Configuración de Cruce de Periodos',
      },
      fields: {
        periodType: 'Tipo de Periodo',
        fiscalYearStartMonth: 'Mes de Inicio del Año Fiscal',
        allowStraddleCompletion: 'Permitir Completar Cruce de Periodos',
        straddleWindowPeriods: 'Ventana de Cruce (Periodos)',
        requireStraddleApproval: 'Requerir Aprobación de Cruce',
      },
      periodTypeOptions: {
        CalendarMonth: 'Mes Calendario',
        FiscalPeriod: 'Periodo Fiscal',
      } as Record<string, string>,
      months: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      } as Record<number, string>,
      actions: {
        save: 'Guardar',
        cancel: 'Cancelar',
      },
      messages: {
        createSuccess: 'Configuración de periodos creada exitosamente',
        updateSuccess: 'Configuración de periodos actualizada exitosamente',
        createError: (message: string) =>
          `Error al crear la configuración de periodos: ${message}`,
        updateError: (message: string) =>
          `Error al actualizar la configuración de periodos: ${message}`,
      },
      validation: {
        fiscalYearStartMonthRequired:
          'El mes de inicio del año fiscal es requerido para periodos fiscales',
      },
    },
  },
  tagsListView: {
    title: 'Etiquetas de Inventario',
    subtitle:
      'Administrar etiquetas de inventario para seguimiento de materiales',
    createTag: 'Crear Etiqueta',
    filters: {
      search: 'Buscar etiquetas...',
      allFacilities: 'Todas las Instalaciones',
      allTypes: 'Todos los Tipos',
      allStatuses: 'Todos los Estados',
    },
    summary: {
      totalTags: 'Total de Etiquetas',
      activeTags: 'Activas',
      draftTags: 'Borrador',
      inInventoryTags: 'En Inventario',
    },
    table: {
      aria: 'Lista de Etiquetas de Inventario',
      columns: {
        tagNumber: 'Número de Etiqueta',
        facility: 'Instalación',
        tagType: 'Tipo',
        status: 'Estado',
        netQuantity: 'Cant. Neta',
        generatedAt: 'Generado',
        lot: 'Lote',
      },
    },
    tagTypes: {
      WorkInProgress: 'Trabajo en Progreso',
      FinishedGood: 'Producto Terminado',
    },
    statusTypes: {
      Active: 'Activo',
      Revised: 'Revisado',
      Cancelled: 'Cancelado',
      Confirmed: 'Confirmado',
      Draft: 'Borrador',
      InInventory: 'En Inventario',
      InTransfer: 'En Transferencia',
      Loaded: 'Cargado',
      PendingPurchase: 'Compra Pendiente',
      Reserved: 'Reservado',
      Shipped: 'Enviado',
      Sold: 'Vendido',
      Transferred: 'Transferido',
      Voided: 'Anulado',
    },
    captureMethods: {
      Automatic: 'Automático',
      Manual: 'Manual',
    },
    content: {
      error: (message: string) =>
        `Error al cargar etiquetas de inventario: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron etiquetas',
      subtitle:
        'Ninguna etiqueta de inventario coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree una nueva etiqueta.',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar Etiqueta',
      deleteSuccess: 'Etiqueta eliminada exitosamente',
      deleteError: (message: string) =>
        `Error al eliminar etiqueta: ${message}`,
    },
    confirmDelete: {
      title: 'Eliminar Etiqueta',
      description: (tagNumber: string) =>
        `¿Está seguro de que desea eliminar la etiqueta "${tagNumber}"? Esta acción no se puede deshacer.`,
      confirm: 'Eliminar Etiqueta',
      cancel: 'Cancelar',
    },
    dialog: {
      createTitle: 'Crear Etiqueta de Inventario',
      editTitle: 'Editar Etiqueta de Inventario',
      tagNumberLabel: 'Número de Etiqueta',
      tagNumberPlaceholder: 'Dejar vacío para generación automática...',
      tagTypeLabel: 'Tipo de Etiqueta',
      statusLabel: 'Estado',
      itemLabel: 'Artículo',
      itemPlaceholder: 'Seleccione un artículo...',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione una instalación...',
      lotLabel: 'Lote de Inventario',
      lotPlaceholder: 'Seleccionar lote (opcional)',
      generatedAtLabel: 'Generado',
      grossQuantityLabel: 'Cantidad Bruta',
      tareLabel: 'Tara',
      netQuantityLabel: 'Cantidad Neta',
      quantityCaptureMethodLabel: 'Método de Captura de Cantidad',
      tareCaptureMethodLabel: 'Método de Captura de Tara',
      isRevisedLabel: 'Revisado',
      cancel: 'Cancelar',
      create: 'Crear Etiqueta',
      creating: 'Creando...',
      update: 'Actualizar Etiqueta',
      updating: 'Actualizando...',
      createSuccess: 'Etiqueta creada exitosamente',
      updateSuccess: 'Etiqueta actualizada exitosamente',
      createError: (message: string) => `Error al crear etiqueta: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar etiqueta: ${message}`,
      unknownError: 'Error desconocido',
      validation: {
        tagTypeRequired: 'El tipo de etiqueta es obligatorio',
        statusRequired: 'El estado es obligatorio',
        itemRequired: 'El artículo es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
        generatedAtRequired: 'La fecha de generación es obligatoria',
        grossQuantityRequired: 'La cantidad bruta es obligatoria',
        tareRequired: 'La tara es obligatoria',
      },
    },
    detail: {
      title: (tagNumber: string) => `Etiqueta ${tagNumber}`,
      backToTags: 'Volver a Etiquetas',
      edit: 'Editar',
      allocateMovements: 'Asignar Movimientos',
      deallocate: 'Desasignar',
      lot: 'Lote',
      netQuantity: 'Cantidad Neta',
      quantitySummary: 'Resumen de Cantidad',
      inQuantity: 'Entrada',
      outQuantity: 'Salida',
      netFromAllocations: 'Neto (Asignaciones)',
      allocations: 'Asignaciones de Movimientos',
      noAllocations: 'No hay movimientos asignados a esta etiqueta',
      table: {
        aria: 'Asignaciones de Etiqueta',
        columns: {
          source: 'Origen',
          item: 'Artículo',
          quantity: 'Cantidad',
          date: 'Asignado',
        },
      },
      allocation: {
        title: 'Asignar Movimientos a Etiqueta',
        searchMovements: 'Buscar Movimientos',
        searchPlaceholder:
          'Buscar por nombre de artículo o número de movimiento...',
        loadingMovements: 'Cargando movimientos...',
        noEligibleMovements: 'No se encontraron movimientos elegibles',
        selectedMovements: (count: number) =>
          `Movimientos Seleccionados (${count})`,
        quantity: 'Cantidad',
        maxAvailable: (max: number, unit: string) => `Máx: ${max} ${unit}`,
        allocate: 'Asignar Seleccionados',
        success: 'Asignado a etiqueta exitosamente',
        error: 'Error al asignar a etiqueta',
      },
    },
  },
  cycleCountSchedulesView: {
    title: 'Programas de Conteo Cíclico',
    subtitle: 'Administrar configuraciones de conteo cíclico programado',
    createSchedule: 'Crear Programa',
    filters: {
      allFacilities: 'Todas las Instalaciones',
    },
    summary: {
      totalSchedules: 'Total de Programas',
      activeSchedules: 'Activos',
      inactiveSchedules: 'Inactivos',
    },
    table: {
      aria: 'Lista de Programas de Conteo Cíclico',
      columns: {
        name: 'Nombre',
        facility: 'Instalación',
        frequency: 'Frecuencia',
        scopeType: 'Alcance',
        isActive: 'Estado',
        lastGeneratedAt: 'Última Generación',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar programas de conteo cíclico: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron programas',
      subtitle:
        'Ningún programa de conteo cíclico coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo programa.',
    },
    actions: {
      edit: 'Editar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      delete: 'Eliminar',
      activateSuccess: 'Programa activado exitosamente',
      deactivateSuccess: 'Programa desactivado exitosamente',
      toggleError: (message: string) =>
        `Error al cambiar estado del programa: ${message}`,
      deleteSuccess: 'Programa eliminado exitosamente',
      deleteError: (message: string) =>
        `Error al eliminar programa: ${message}`,
    },
    confirmDelete: {
      title: 'Eliminar Programa',
      description: (name: string) =>
        `¿Está seguro de que desea eliminar el programa "${name}"? Esta acción no se puede deshacer.`,
      confirm: 'Eliminar Programa',
      cancel: 'Cancelar',
    },
    dialog: {
      createTitle: 'Crear Programa de Conteo Cíclico',
      editTitle: 'Editar Programa de Conteo Cíclico',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione una instalación...',
      nameLabel: 'Nombre',
      namePlaceholder: 'Ingrese nombre del programa...',
      frequencyLabel: 'Frecuencia',
      scopeTypeLabel: 'Tipo de Alcance',
      toleranceLabel: 'Tolerancia Predeterminada (%)',
      blindCountLabel: 'Conteo Ciego',
      cancel: 'Cancelar',
      create: 'Crear Programa',
      creating: 'Creando...',
      update: 'Actualizar Programa',
      updating: 'Actualizando...',
      createSuccess: 'Programa creado exitosamente',
      updateSuccess: 'Programa actualizado exitosamente',
      createError: (message: string) => `Error al crear programa: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar programa: ${message}`,
      unknownError: 'Error desconocido',
      validation: {
        nameRequired: 'El nombre es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
  },
  cycleCountTasksView: {
    title: 'Tareas de Conteo Cíclico',
    subtitle: 'Administrar y ejecutar tareas de conteo de inventario',
    filters: {
      search: 'Buscar tareas...',
      allFacilities: 'Todas las Instalaciones',
      allStatuses: 'Todos los Estados',
      allCountTypes: 'Todos los Tipos de Conteo',
    },
    table: {
      aria: 'Lista de Tareas de Conteo Cíclico',
      columns: {
        taskNumber: 'Número de Tarea',
        facility: 'Instalación',
        countType: 'Tipo de Conteo',
        status: 'Estado',
        assignedTo: 'Asignado a',
        dueDate: 'Fecha Límite',
      },
    },
    statusTypes: {
      Pending: 'Pendiente',
      InProgress: 'En Progreso',
      Completed: 'Completado',
      Approved: 'Aprobado',
      Cancelled: 'Cancelado',
    } as Record<string, string>,
    countTypes: {
      CycleCount: 'Conteo Cíclico',
      PhysicalInventory: 'Inventario Físico',
      SpotCheck: 'Verificación Rápida',
    } as Record<string, string>,
    content: {
      error: (message: string) =>
        `Error al cargar tareas de conteo cíclico: ${message}`,
    },
    createTask: {
      button: 'Crear Tarea',
      dialogTitle: 'Crear Tarea de Conteo Cíclico',
      facility: 'Instalación',
      countType: 'Tipo de Conteo',
      dueDate: 'Fecha Límite',
      assignedTo: 'Asignado a',
      blindCount: 'Conteo Ciego',
      tolerancePercentage: 'Tolerancia %',
      notes: 'Notas',
      notesPlaceholder: 'Notas opcionales...',
      submit: 'Crear',
      cancel: 'Cancelar',
      success: 'Tarea de conteo cíclico creada',
      error: (message: string) => `Error al crear tarea: ${message}`,
      countTypes: {
        Full: 'Completo',
        Category: 'Categoría',
        Zone: 'Zona',
        Abc: 'ABC',
        Value: 'Valor',
      } as Record<string, string>,
    },
    emptyState: {
      title: 'No se encontraron tareas',
      subtitle:
        'Ninguna tarea de conteo cíclico coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda.',
    },
    detail: {
      title: (taskNumber: string) => `Tarea de Conteo ${taskNumber}`,
      backToTasks: 'Volver a Tareas',
      linesTab: 'Líneas de Conteo',
      noLines: 'No hay líneas de conteo para esta tarea',
      hidden: 'Oculto',
      countedQuantity: 'Cantidad Contada',
      info: {
        countType: 'Tipo de Conteo',
        assignedTo: 'Asignado a',
        dueDate: 'Fecha Límite',
        blindCount: 'Conteo Ciego',
        yes: 'Sí',
        no: 'No',
        startedAt: 'Iniciado',
        completedAt: 'Completado',
        approvedAt: 'Aprobado',
        approvedBy: 'Aprobado Por',
      },
      linesTable: {
        item: 'Artículo',
        account: 'Cuenta',
        expected: 'Cant. Esperada',
        counted: 'Cant. Contada',
        variance: 'Varianza',
        tolerance: 'Tolerancia',
        adjustmentStatus: 'Est. Ajuste',
        actions: 'Acciones',
      },
      actions: {
        start: 'Iniciar Conteo',
        complete: 'Completar Conteo',
        approve: 'Aprobar',
        cancel: 'Cancelar',
        startSuccess: 'Tarea de conteo iniciada',
        completeSuccess: 'Tarea de conteo completada',
        approveSuccess: 'Tarea de conteo aprobada',
        cancelSuccess: 'Tarea de conteo cancelada',
        startError: (message: string) =>
          `Error al iniciar tarea de conteo: ${message}`,
        completeError: (message: string) =>
          `Error al completar tarea de conteo: ${message}`,
        approveError: (message: string) =>
          `Error al aprobar tarea de conteo: ${message}`,
        approveUnresolvedLinesError:
          'Todas las líneas que requieren aprobación deben ser aprobadas o rechazadas antes de aprobar la tarea.',
        cancelError: (message: string) =>
          `Error al cancelar tarea de conteo: ${message}`,
        reopen: 'Reabrir',
        reopenSuccess: 'Tarea de conteo reabierta',
        reopenError: (message: string) =>
          `Error al reabrir tarea de conteo: ${message}`,
        unknownError: 'Error desconocido',
      },
      saveCounts: 'Guardar Conteos',
      saveCountsSuccess: 'Conteos guardados exitosamente',
      saveCountsError: (message: string) =>
        `Error al guardar conteos: ${message}`,
      saveCountsPartialError: (succeeded: number, failed: number) =>
        `${succeeded} conteo(s) guardado(s), ${failed} fallaron. Por favor reintente las entradas fallidas.`,
      lineActions: {
        approve: 'Aprobar Ajuste',
        reject: 'Rechazar Ajuste',
        recount: 'Solicitar Reconteo',
        recountRequested: 'Reconteo Solicitado',
        costOverride: 'Costo Unitario Manual',
        costOverridePlaceholder: 'CMP',
        approveSuccess: 'Ajuste aprobado',
        approveError: (message: string) =>
          `Error al aprobar ajuste: ${message}`,
        rejectSuccess: 'Ajuste rechazado',
        rejectError: (message: string) =>
          `Error al rechazar ajuste: ${message}`,
        recountSuccess: 'Reconteo solicitado',
        recountError: (message: string) =>
          `Error al solicitar reconteo: ${message}`,
      },
    },
  },
  logs: {
    rawPayloadParseError: 'Carga útil sin procesar (Error de análisis)',
    unknownEventType: 'Tipo de evento desconocido',
    unknownEvent: 'Evento desconocido',
    noDataAvailable: 'No hay datos disponibles',
    events: {
      categoryCreated: 'Categoría Creada',
      categoryUpdated: 'Categoría Actualizada',
      categoryDeleted: 'Categoría Eliminada',
      itemCreated: 'Artículo Creado',
      itemUpdated: 'Artículo Actualizado',
      itemDeleted: 'Artículo Eliminado',
      itemGroupCreated: 'Grupo de Artículos Creado',
      itemGroupUpdated: 'Grupo de Artículos Actualizado',
      itemGroupDeleted: 'Grupo de Artículos Eliminado',
      inventoryTagCreated: 'Etiqueta de Inventario Creada',
      inventoryTagUpdated: 'Etiqueta de Inventario Actualizada',
      inventoryTagDeleted: 'Etiqueta de Inventario Eliminada',
    },
  },
};

export type TranslationsType = typeof es;
